<template>
  <div>
    <div
      ref="modal"
      class="modal fade"
      :class="{ show: active, 'd-block': active }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create Segment SAP</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              v-on:click="$emit('closeModal')"
              aria-label="btn-close"
            ></button>
          </div>
          <div class="modal-body">
        
            <div class="row">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Order Group
                  </label>
                </div>
                <div class="col-lg-8">
                   

                    <v-select
                    :options="dropDownOrderGroup"
                    v-model="forms.order_group"
                    label="value"
                    return-object
                    @search="asyncSearchOrderGroup"
                    ></v-select>

                  <div
                    v-for="error in errors.order_group"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Value
                  </label>
                </div>
                <div class="col-lg-8">
                  
                    <input
                        type="text"
                        v-model="forms.value"
                        class="form-control form-control-sm"
                        maxlength="15"
                        required
                        />

                  <div
                    v-for="error in errors.value"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>



            <div class="row">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Active
                  </label>
                </div>
                <div class="col-lg-8">
                  
                     <input
                            type="checkbox"
                            v-model="forms.active"
                            class="form-check-input"
                            id="userCheckActive"
                            true-value="ACTIVE"
                            false-value="INACTIVE"
                          />

                  <div
                    v-for="error in errors.active"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="row mb-3">
                <div class="col-lg-3">
                  <label
                    for="defaultconfig"
                    class="col-form-label"
                    style="padding-left: 25px"
                    >Remark
                  </label>
                </div>
                <div class="col-lg-8">
                  
                     <textarea class="form-control" v-model="forms.remark" ></textarea>

                  <div
                    v-for="error in errors.remark"
                    :key="error"
                    class="alert alert-primary"
                    role="alert"
                  >
                    <i data-feather="alert-circle"></i>
                    {{ error }}
                  </div>
                </div>
              </div>
            </div>



          </div>
          <div class="modal-footer">
            <button
              :disabled="isLoading"
              type="button"
              class="btn btn-secondary"
              v-on:click="$emit('closeModal')"
            >
              cancel
            </button>
            <button
              :disabled="isLoading"
              type="button"
              class="btn btn-success"
              v-on:click="submitData()"
            >
              Save & Close
            </button>
  
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 
export default {
  name: "modalTransportationSegmentCreate",
  emits: ["closeModal"],
  components: {
     
  },
  props: {
    showModal: Boolean,
    data: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        const body = document.querySelector("body");
     
        this.asyncSearchOrderGroup();
        this.resetForm();

        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    const startDate = new Date();
    const endDate = new Date();
    return {
        dropDownOrderGroup:[],
        isLoading: false,
        opens: "center",
        active: this.showModal,
        effective_date: {
            startDate,
            endDate,
        },
        expiration_date: {
            startDate,
            endDate,
        },
        isSearchingCustTujuan:false,
        forms: {
            transportation_segment_id:'',
            order_group:'',
            value:'',
            active:'ACTIVE',
            remark:'',
            create_by:'',
            update_by:'',
            created_at:'',
            updated_at:'',
        },
        errors: [],
        locale: {
            format: "dd mmm yyyy H:MM:ss",
        },
    };
  },
  methods: {

    onOrderGroupPicked(item) {
      this.forms.order_group = item?.value ?? null;
    //   console.log(item)
    },

    asyncSearchOrderGroup() {
      this.isSearchingCustTujuan = true;
      const baseURI = this.$settings.endPoint + "/transportation-segment/get-master-lookup";
      return this.$http
        .get(baseURI)
        .then((response) => {
          this.dropDownOrderGroup = response.data.datas;
        })
        .finally(() => {
          this.isSearchingCustTujuan = false;
        });
    },
 

    submitData() {
 
      this.isLoading = true;
      var sendData = {
            order_group: this.forms.order_group.value,
            value:this.forms.value,
            active:this.forms.active,
            remark:this.forms.remark
      };
      const baseURI =
        this.$settings.endPoint +
        "transportation-segment/store";
      return this.$http
        .post(baseURI, sendData)
        .then((response) => {
            this.isLoading = false;
          if (response.data.status === 200) {
            this.$emit("closeModal");
            this.success2('success');
            this.errors = [];
          } else {
            this.errors = response.data.errors;
            this.resultError(response.data.errors);
          }
          
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 500) {
              this.error(error.response.data.errors.message);
            } else {
              this.$router.push("/page-not-found");
            }
          }
     
        });
        
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },
    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
    resultError(data) {
      var html = "";
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          html += objectData[y] + "<br>";
        }
      }

      this.loadError(html);
    },
    success2(msg) {
      this.$swal({
        icon: "info",
        backdrop: true,
        title: "Information",
        html: "<p>* " + msg + "</p>",
        showConfirmButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    },
    resetForm(){
        this.errors = [];
        this.forms = {

            transportation_segment_id:'',
            order_group:'',
            value:'',
            active:'ACTIVE',
            remark:'',
            create_by:'',
            update_by:'',
            created_at:'',
            updated_at:'',

        }
    }
  },
  mounted() {

  },
};
</script>
<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>
